import { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { GetSessionStorageData } from "../helper";
import { ROUTES, TOKENS } from "../Constants/Constants";

const PublicRoutesCheck = () => {
  const token = GetSessionStorageData(TOKENS.ACCESS_TOKEN);
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = () => {
      const currentToken = GetSessionStorageData(TOKENS.ACCESS_TOKEN);
      if (currentToken) {
        navigate(ROUTES.DASHBOARD);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  if (token) {
    return <Navigate to={ROUTES.DASHBOARD} />;
  }

  return <Outlet />;
};

export default PublicRoutesCheck;